"use client";

import LandingComingSoon from '../../../components/landing/CommingSoon';

export default function CommingSoonPage() {
    return <LandingComingSoon />;
}
